import { ISite } from './ISite';

export interface IEstateView {
    corporationId: string;
    corporationName: string;
    sites: ISite[];
}

export class EstateView implements IEstateView {
    corporationId: string;
    corporationName: string;
    sites: ISite[];

    constructor() {
        this.corporationId = '';
        this.corporationName = '';
        this.sites = [];
    }
}
